import React, { Fragment, useEffect, useState, useContext } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import VisibilityICon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import userContext from "contexts/userContext";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import { colors } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import LinearProgress from "@material-ui/core/LinearProgress";

import {
  Grid,
  Card,
  IconButton,
  Divider,
  Typography,
  Tooltip,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";

const Field = (props) => (
  <FormControl fullWidth>
    <TextField
      readOnly
      label={props.label}
      variant="filled"
      InputLabelProps={{
        shrink: true,
        focused: true,
      }}
      value={props.value}
    ></TextField>
  </FormControl>
);
export default function LivePreviewExample(props) {
  const { role, setRole } = useContext(userContext);
  const [open, toggleOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [hData, setHData] = useState([]);
  const [changes, setChanges] = useState({});
  const [show, setShow] = useState([]);
  const handleClose = () => {
    toggleOpen(false);
  };
  // const calcDiff = (date) => {
  //   let _date = new Date(date);
  //   let _now = new Date();

  //   let _diff = (_now - _date) / 1000;
  //   if (_diff < 60) {
  //     return "Il y a " + Math.round(_diff) + " secondes";
  //   } else if (_diff < 3600) {
  //     return "Il y a " + Math.round(_diff / 60) + " minutes";
  //   } else if (_diff < 60 * 60 * 24) {
  //     return "Il y a " + Math.round(_diff / 60 / 60) + " heures";
  //   } else if (_diff < 60 * 60 * 24 * 7) {
  //     return "Il y a " + Math.round(_diff / 60 / 60 / 24) + " jours";
  //   } else if (_diff < 60 * 60 * 24 * 7 * 4) {
  //     return "Il y a " + Math.round(_diff / 60 / 60 / 24 / 7) + " semaines";
  //   } else if (_diff < 60 * 60 * 24 * 7 * 4) {
  //     return "Il y a " + Math.round(_diff / 60 / 60 / 24 / 7 / 4) + " mois";
  //   } else {
  //     return "Il y a " + Math.round(_diff / 12 / 4 / 7 / 24 / 60 / 60) + " ans";
  //   }
  // };

  useEffect(() => {
    const MONOLITH_API_URL = process.env.REACT_APP_MONOLITH_API_URL;
    const SECURITY_API_URL = process.env.REACT_APP_SECURITYAPI_URL;
    console.log("props : ", props);
    let config = {
      method: "GET",
      maxBodyLength: Infinity,
      url: MONOLITH_API_URL + "/api/bescs/" + props.bescId + "/history",
      headers: {
        "Content-Type": "application/ld+json",
        Authorization: "Bearer " + localStorage.getItem("TOKEN_BEARER"),
      },
    };
    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        console.log("reponse : ", response);
        let _hdata = [...response.data.results];
        let _show = [...show];
        for (let _h of _hdata) {
          _show.push(false);
        }
        setShow(_show);
        for (let el of _hdata) {
          console.log("el : ", el);
          let _arr = el.date.split(" ");
          el.date = _arr[0];
          el.heure = _arr[1];
        }
        console.log("_hdata after change : ", _hdata);
        setHData(_hdata);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error!! error below :");
        console.log(error);
        return error;
      });
  }, []);

  useEffect(() => {
    console.log("hData changed, hData : ", hData);
  }, [hData]);

  useEffect(() => {
    console.log("changes changed, changes : ", changes);
    console.log("keys : ", Object.entries(changes));
  }, [changes]);

  return (
    <Fragment>
      {loading ? (
        <LinearProgress variant="query" className="mb-3" />
      ) : (
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          alignSelf="center"
          spacing={1}
          xs={12}
        >
          <Timeline align="left">
            <Grid item xs={12} sm={12} md={12}>
              {hData.map((item, index) =>
                index == 0 || hData[index].date !== hData[index - 1].date ? (
                  <>
                    <TimelineItem>
                      <TimelineOppositeContent style={{ flex: 0.1 }}>
                        <Typography variant="body2" color="textSecondary">
                          {item.date}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot color="secondary">
                          <CalendarTodayIcon style={{ fontSize: 10 }} />
                        </TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>

                      <TimelineContent>
                        <Divider className="my-3" />
                        <Typography variant="body2" color="textSecondary">
                          {/* {item.date} */}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                    <TimelineItem>
                      <TimelineOppositeContent style={{ flex: 0.1 }}>
                        <Typography variant="body2" color="textSecondary">
                          {/* {item.heure.substring(0, 5)} */}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot color="primary">
                          <FiberManualRecordIcon style={{ fontSize: 10 }} />
                        </TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>

                      <TimelineContent>
                        <Typography variant="body2" color="textSecondary">
                          {item.heure.substring(0, 5)}
                        </Typography>
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                          alignSelf="center"
                          spacing={1}
                          xs={12}
                        >
                          <Grid item xs={4} sm={4} md={4}>
                            <Typography variant="h6" component="h1">
                              {item.operation}
                            </Typography>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4}>
                            <Typography variant="h6" component="h1">
                              {item.auteur}
                            </Typography>
                          </Grid>
                          {/* <Grid item xs={4} sm={4} md={4}>
                              <Typography variant="h6" component="h1">
                                {calcDiff(item.date + " " + item.heure)}
                              </Typography>
                            </Grid> */}
                        </Grid>

                        {Object.entries(item.diffs).length > 0 && (
                          <div className="mt-2">
                            <Tooltip title={show[index] ? "Masquer" : "Voir"}>
                              <IconButton
                                aria-label="delete"
                                size="small"
                                variant="contained"
                                hidden={
                                  item.operation !== "Modification du BESC"
                                }
                                color="text"
                                onClick={() => {
                                  console.log("UP");
                                  console.log(Object.entries(item.diffs));
                                  let _show = [...show];
                                  _show[index] = !_show[index];
                                  setShow(_show);
                                }}
                              >
                                {show[index] ? (
                                  <VisibilityICon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </Tooltip>
                          </div>
                        )}

                        {item.operation === "Modification du BESC" &&
                          show[index] &&
                          Object.entries(item.diffs).length > 0 && (
                            <TableContainer>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="center">Champ</TableCell>
                                    <TableCell align="center">
                                      Ancienne Valeur
                                    </TableCell>
                                    <TableCell align="center">
                                      Nouvelle Valeur
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {Object.entries(item.diffs).map(
                                    (change, index) => (
                                      <>
                                        <TableRow hover>
                                          <TableCell
                                            align="center"
                                            component="th"
                                            scope="row"
                                            padding="none"
                                          >
                                            {change[0]}
                                          </TableCell>
                                          <TableCell
                                            align="center"
                                            component="th"
                                            scope="row"
                                            padding="none"
                                          >
                                            {change[1].old}
                                          </TableCell>
                                          <TableCell
                                            align="center"
                                            component="th"
                                            scope="row"
                                            padding="none"
                                          >
                                            {change[1].new.id
                                              ? change[1].new.id
                                              : change[1].new}
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    )
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                      </TimelineContent>
                    </TimelineItem>
                  </>
                ) : (
                  <TimelineItem>
                    <TimelineOppositeContent style={{ flex: 0.1 }}>
                      <Typography variant="body2" color="textSecondary">
                        {/* {item.heure.substring(0, 5)} */}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color="primary">
                        <FiberManualRecordIcon style={{ fontSize: 10 }} />
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>

                    <TimelineContent>
                      <Typography variant="body2" color="textSecondary">
                        {item.heure.substring(0, 5)}
                      </Typography>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        alignSelf="center"
                        spacing={1}
                        xs={12}
                      >
                        <Grid item xs={4} sm={4} md={4}>
                          <Typography variant="h6" component="h1">
                            {item.operation}
                          </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4}>
                          <Typography variant="h6" component="h1">
                            {item.auteur}
                          </Typography>
                        </Grid>
                        {/* <Grid item xs={4} sm={4} md={4}>
                            <Typography variant="h6" component="h1">
                              {calcDiff(item.date + " " + item.heure)}
                            </Typography>
                          </Grid> */}
                      </Grid>

                      {Object.entries(item.diffs).length > 0 && (
                        <div className="mt-2">
                          <Tooltip title={show[index] ? "Masquer" : "Voir"}>
                            <IconButton
                              aria-label="delete"
                              size="small"
                              variant="contained"
                              hidden={item.operation !== "Modification du BESC"}
                              color="text"
                              onClick={() => {
                                console.log("DOWN");
                                let _show = [...show];
                                _show[index] = !_show[index];
                                setShow(_show);
                              }}
                            >
                              {show[index] ? (
                                <VisibilityICon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}

                      {item.operation === "Modification du BESC" &&
                        show[index] &&
                        Object.entries(item.diffs).length > 0 && (
                          <TableContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">Champ</TableCell>
                                  <TableCell align="center">
                                    Ancienne Valeur
                                  </TableCell>
                                  <TableCell align="center">
                                    Nouvelle Valeur
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {Object.entries(item.diffs).map(
                                  (change, index) => (
                                    <>
                                      <TableRow hover>
                                        <TableCell
                                          align="center"
                                          component="th"
                                          scope="row"
                                          padding="none"
                                        >
                                          {change[0]}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          component="th"
                                          scope="row"
                                          padding="none"
                                        >
                                          {change[1].old}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          component="th"
                                          scope="row"
                                          padding="none"
                                        >
                                          {change[1].new && change[1].new.id
                                            ? change[1].new.id
                                            : change[1].new}
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          // {/* <Tooltip title="Voir">
                          //   <IconButton
                          //     aria-label="delete"
                          //     size="small"
                          //     variant="contained"
                          //     color="text"
                          //     onClick={() => {
                          //       console.log("item diff : ", item.diffs);
                          //       console.log(
                          //         "keys : ",
                          //         Object.entries(item.diffs)
                          //       );
                          //       setChanges(item.diffs);
                          //       toggleOpen(true);
                          //     }}
                          //   >
                          //     <VisibilityICon />
                          //   </IconButton>
                          // </Tooltip> */}
                        )}
                    </TimelineContent>
                  </TimelineItem>
                )
              )}
            </Grid>
          </Timeline>
        </Grid>
      )}

      <Dialog
        maxWidth="xl"
        fullWidth
        fullScreen
        scroll="body"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Changements effectués</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ci-dessous les changements effectués sur le BESC
          </DialogContentText>
          {/* <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            alignContent="flex-start"
            alignSelf="center"
            className="card-header font-size-md font-weight-bold"
            spacing={1}
          >
            <Grid item fullWidth xs={6} sm={4} md={2}>
              <Typography variant="h6">Champ</Typography>
            </Grid>
            <Grid item fullWidth xs={12} sm={10} md={5}>
              <Typography variant="h6">Ancienne Valeur</Typography>
            </Grid>
            <Grid item fullWidth xs={12} sm={10} md={5}>
              <Typography variant="h6">Nouvelle Valeur</Typography>
            </Grid>
            {Object.entries(changes).map((change, index) => (
              <>
                <Grid item fullWidth xs={6} sm={4} md={2}>
                  <Typography variant="h6">{change[0]}</Typography>
                </Grid>
                <Grid item fullWidth xs={12} sm={10} md={5}>
                  <Field label={change[0]} value={change[1].old} />
                </Grid>
                <Grid item fullWidth xs={12} sm={10} md={5}>
                  <Field label={change[0]} value={change[1].old} />
                </Grid>
              </>
            ))}
          </Grid> */}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Champ</TableCell>
                  <TableCell align="center">Ancienne Valeur</TableCell>
                  <TableCell align="center">Nouvelle Valeur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(changes).map((change, index) => (
                  <>
                    <TableRow hover>
                      <TableCell
                        align="center"
                        component="th"
                        scope="row"
                        padding="none"
                      >
                        {change[0]}
                      </TableCell>
                      <TableCell
                        align="center"
                        component="th"
                        scope="row"
                        padding="none"
                      >
                        {change[1].old}
                      </TableCell>
                      <TableCell
                        align="center"
                        component="th"
                        scope="row"
                        padding="none"
                      >
                        {change[1].new.id ? change[1].new.id : change[1].new}
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
